<template>
    <div class="manage--left" ref="lesson-left">
        <!-- Tìm kiếm -->
        <div class="manage--search--left">
            <input type="text" autocomplete="off" v-model="keyword" :placeholder="$t('search.keyWord')" class="input--search--left" />
            <button type="button" @click="search({keyword: keyword, from: from, to: to})" class="button--search--left">
                <img :src="$CONST.HEADER.IMG.SEARCH" />
            </button>
        </div>

        <div style="margin-top: 2px;">
            <el-date-picker class="inputDate" v-model="from" type="date" align="right" size="mini" :picker-options="startDate" value-format="yyyy/MM/dd"> </el-date-picker>
            <span style="font-size: 20px;">&#8764;</span>
            <el-date-picker class="inputDate" v-model="to" type="date" align="right" size="mini" :picker-options="startDate" value-format="yyyy/MM/dd"> </el-date-picker>
        </div>

        <!-- Nội dung -->
        <div class="div-list-lessons" :class="{ht: !mobile}">
            <!-- Danh sách -->
            <template v-for="(item, index) in lessons">
                <div class="nqt--list--lessons" :class="[{active: activeItem.courseLiveId == item.courseLiveId}]" v-on:click="changeItem(item)" :key="index">
                    <p class="title-lesson">
                        <template>
                            <b>{{item.courseName}}</b>
                            <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                                <i>{{item.liveDate}}</i>
                                <div style="display: flex;">
                                    <div class="lkt-icon-present-absent">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" viewBox="0 0 172 172">
                                            <g
                                                fill="none"
                                                fill-rule="nonzero"
                                                stroke="none"
                                                stroke-width="1"
                                                stroke-linecap="butt"
                                                stroke-linejoin="miter"
                                                stroke-miterlimit="10"
                                                stroke-dasharray=""
                                                stroke-dashoffset="0"
                                                font-family="none"
                                                font-weight="none"
                                                font-size="none"
                                                text-anchor="none"
                                                style="mix-blend-mode: normal;"
                                            >
                                                <path d="M0,172v-172h172v172z" fill="none"></path>
                                                <g fill="#e74c3c">
                                                    <path
                                                        d="M86,17.2112c-24.3208,0 -34.4,15.6004 -34.4,34.4c0,6.3296 3.02344,12.68724 3.02344,12.68724c-1.21547,0.69947 -3.21443,2.91979 -2.7099,6.86432c0.94027,7.35587 4.12925,9.22906 6.15885,9.38386c0.774,6.8628 8.14761,15.64152 10.72761,16.92005v11.46667c-5.73333,17.2 -51.6,5.73333 -51.6,45.86667h68.49766c-3.44573,-6.9144 -5.43099,-14.68307 -5.43099,-22.93333c0,-21.86693 13.62563,-40.5172 32.83229,-48.02786c0.3956,-1.12373 0.70825,-2.23152 0.82865,-3.29219c2.0296,-0.1548 5.21858,-2.02799 6.15885,-9.38386c0.50454,-3.95027 -1.49443,-6.16485 -2.70989,-6.86432c0,0 3.02344,-5.74418 3.02344,-12.68724c0,-13.92053 -5.46387,-25.8 -17.2,-25.8c0,0 -4.0764,-8.6 -17.2,-8.6zM131.86667,91.73333c-22.16507,0 -40.13333,17.96827 -40.13333,40.13333c0,22.16507 17.96827,40.13333 40.13333,40.13333c22.16507,0 40.13333,-17.96827 40.13333,-40.13333c0,-22.16507 -17.96827,-40.13333 -40.13333,-40.13333zM149.06667,114.66667c1.4663,0 2.93278,0.55882 4.05364,1.67969c2.24173,2.24173 2.24173,5.86556 0,8.10729l-22.93333,22.93333c-1.118,1.118 -2.58591,1.67969 -4.05364,1.67969c-1.46773,0 -2.93564,-0.56169 -4.05364,-1.67969l-11.46667,-11.46667c-2.24173,-2.24173 -2.24173,-5.86556 0,-8.10729c2.24173,-2.24173 5.86556,-2.24173 8.10729,0l7.41302,7.41302l18.87969,-18.87969c1.12087,-1.12087 2.58734,-1.67969 4.05364,-1.67969z"
                                                    ></path>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>{{item.totalStudentJoin}}</span>
                                    </div>
                                    <div class="lkt-icon-present-absent">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 172 172">
                                            <g
                                                fill="none"
                                                fill-rule="nonzero"
                                                stroke="none"
                                                stroke-width="1"
                                                stroke-linecap="butt"
                                                stroke-linejoin="miter"
                                                stroke-miterlimit="10"
                                                stroke-dasharray=""
                                                stroke-dashoffset="0"
                                                font-family="none"
                                                font-weight="none"
                                                font-size="none"
                                                text-anchor="none"
                                                style="mix-blend-mode: normal;"
                                            >
                                                <path d="M0,172v-172h172v172z" fill="none"></path>
                                                <g fill="#cccccc">
                                                    <path
                                                        d="M86,17.2112c-24.3208,0 -34.4,15.6004 -34.4,34.4c0,6.3296 3.02344,12.68724 3.02344,12.68724c-1.21547,0.69947 -3.21443,2.91979 -2.7099,6.86432c0.94027,7.35587 4.12925,9.22906 6.15885,9.38386c0.774,6.8628 8.14761,15.64152 10.72761,16.92005v11.46667c-5.73333,17.2 -51.6,5.73333 -51.6,45.86667h68.49766c-3.44573,-6.9144 -5.43099,-14.68307 -5.43099,-22.93333c0,-21.86693 13.62563,-40.5172 32.83229,-48.02786c0.3956,-1.12373 0.70825,-2.23152 0.82865,-3.29219c2.0296,-0.1548 5.21858,-2.02799 6.15885,-9.38386c0.50454,-3.95027 -1.49443,-6.16485 -2.70989,-6.86432c0,0 3.02344,-5.74418 3.02344,-12.68724c0,-13.92053 -5.46387,-25.8 -17.2,-25.8c0,0 -4.0764,-8.6 -17.2,-8.6zM131.86667,91.73333c-22.16507,0 -40.13333,17.96827 -40.13333,40.13333c0,22.16507 17.96827,40.13333 40.13333,40.13333c22.16507,0 40.13333,-17.96827 40.13333,-40.13333c0,-22.16507 -17.96827,-40.13333 -40.13333,-40.13333zM149.06667,114.66667c1.4663,0 2.93278,0.55882 4.05364,1.67969c2.24173,2.24173 2.24173,5.86556 0,8.10729l-22.93333,22.93333c-1.118,1.118 -2.58591,1.67969 -4.05364,1.67969c-1.46773,0 -2.93564,-0.56169 -4.05364,-1.67969l-11.46667,-11.46667c-2.24173,-2.24173 -2.24173,-5.86556 0,-8.10729c2.24173,-2.24173 5.86556,-2.24173 8.10729,0l7.41302,7.41302l18.87969,-18.87969c1.12087,-1.12087 2.58734,-1.67969 4.05364,-1.67969z"
                                                    ></path>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>{{item.totalStudentNoJoin}}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </p>
                </div>
            </template>
        
            <!-- Loading -->
            <loading class="loading--lesson nqt--loading" :showLoading="loadingAttendance"/>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import loading from "@/components/loading/loading";

    export default {
        data() {
            return {
                keyword: null,
                activeItem: null,
                from: null,
                to: null,
                createEndTime: "",
                startDate: {
                    disabledDate: (time) => {
                        if (this.createEndTime) {
                            return time.getTime() > new Date(this.createEndTime).getTime();
                        }
                    },
                },
            };
        },
        components: {
            loading
        },
        computed: {
            // Tìm kiếm khóa học
            lessons: function () {
                let keyword = this.keyword;
                let result = [];

                if (keyword == null || keyword == "") {
                    result = this.courseOnlineList;
                } else {
                    keyword = keyword.toUpperCase();
                    result = this.courseOnlineList.filter(lesson => lesson.courseName.toUpperCase().indexOf(keyword) > -1);
                }
                return result;
            },

            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                loadingAttendance: (state) => state.manageStudent.loadingAttendance,
                courseOnlineList: (state) => state.manageStudent.courseOnlineList
            }),
        },
        watch: {
            activeItem(value) {
                this.$emit("changeItem", value);
            },
        },
        created() {
            let currentDatetime = new Date();
            let today = currentDatetime.getFullYear() + "/" + this.appendLeadingZeroes(currentDatetime.getMonth() + 1) + "/" + this.appendLeadingZeroes(currentDatetime.getDate());
            this.from = today;
            this.to = today;

            this.search({keyword: this.keyword, from: this.from, to: this.to});
        },
        methods: {

            // format date
            appendLeadingZeroes: function (n) {
                if (n <= 9) {
                    return "0" + n;
                }
                return n;
            },

            // Lấy danh sách khóa học
            search: function (data) {

                // Mở loading
                this.setLoadingAttendance(true);

                this.$api
                    .post("/home/getLiveLesson", {
                        languageType: this.$lang(),
                        courseName: data.keyword,
                        from: data.from,
                        to: data.to
                    })
                    .then((response) => {
                        let result = response.data.list.sort((a, b) =>
                            a.liveDate == b.liveDate ? a.liveTimeStart.localeCompare(b.liveTimeStart) : a.liveDate.localeCompare(b.liveDate)
                        );
                        
                        if (response.data.list.length > 0) {
                            this.activeItem = result[0];
                        }

                        // Lưu dữ liệu vào store
                        this.setCourseOnlineList(result);
                        this.setShowCoursesOnline(result);

                        // Đóng loading
                        this.setLoadingAttendance(false);
                        
                    })
                    .catch((err) => {});
            },

            ...mapMutations("manageStudent", ["setShowCoursesOnline", "setLoadingAttendance", "setCourseOnlineList"]),

            // Thay đổi khóa học
            changeItem: function (item) {
                this.activeItem = item;
                document.getElementsByTagName("body")[0].classList.remove("show-menu-1");
            },
        },
    };
</script>
<style scoped>
    .nqt--loading {
        position: absolute;
    }
    .lkt-icon-present-absent {
        width: 50px;
    }
    .inputDate {
        max-width: 127px !important;
    }
    .el-col-2 {
        margin-top: 5px;
        text-align: center;
    }
    .el-form-item {
        padding: 0px !important;
        margin-bottom: 0px !important;
    }
    .button--search--left {
        width: auto;
        /* height: auto; */
    }
    .nqt--list--lessons {
        cursor: pointer !important;
    }
    .div-list-lessons {
        cursor: pointer !important;
        overflow: auto;
        height: 675px;
        position: relative;
    }
    .nqt-end {
        background: #1f1313;
        height: calc(100% - 10px);
        position: absolute;
        right: 5px;
        width: auto;
        top: 5px;
        color: #fff;
        padding: 7px;
        font-size: 10px;
        border-radius: 7px;
        display: flex;
    }
    .nqt--list--lessons:hover {
        background: #d7d7d7;
    }
    .isTeacher {
        color: #9b99a2;
    }
    .btn_download {
        background: transparent;
        border: none;
        border-radius: 5px;
        margin-left: 2px;
    }
    .btn_download:hover {
        background: #d7d7d7;
    }
    /* custom */
    .div-list-lessons {
        border: 1px solid #e3e3e3;
        padding: 5px;
        border-radius: 5px;
        margin-top: 5px;
        padding-bottom: 0;
    }
    .ht {
        height: calc(100% - 80px) !important;
    }
    .nqt--list--lessons {
        border-bottom: 1px solid #e3e3e3;
    }
    .nqt--list--lessons.active,
    .nqt--list--lessons b {
        color: #0071c5;
    }
    .nqt--list--lessons.active,
    .nqt--list--lessons {
        color: #000;
        border-radius: 5px;
    }
    /* .nqt--list--lessons.active, .nqt--list--lessons b:hover {
        background: #0071c5;
        color: #fff !important;
        border-radius: 10px;
    } */
    .active {
        color: #fff !important;
    }
    .active b {
        color: #fff;
    }
    .active:hover {
        background: #0071c5;
    }
    .manage--left {
        box-shadow: none;
        padding-top: 0;
        padding-bottom: 0;
        border: none;
    }
    .search--type {
        display: flex;
        justify-content: center;
        height: 36px;
        margin-bottom: 5px;
    }
    .search--type--btn {
        border: 0;
        color: #e3e3e3;
        font-size: 12px;
        width: 50%;
        background: transparent;
        font-weight: 300;
    }
    .search--type--btn.active--nqt {
        color: #0071c5;
        border-bottom: 2px solid #0071c5;
    }
    @media (max-width: 480px) {
        .inputDate {
            width: calc(50% - 13px);
            max-width: 100% !important;
            -webkit-appearance: none;
            -moz-appearance: none;
        }
        .el-date-editor.el-input .el-input__inner {
            width: 154px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/left/attendances.vue